export function initializeDateFromQuery(setScheduleDate: (date: Date) => void) {
    if (location.search) {
        const dateString = location.search.split('?date=')[1]
        setScheduleDate(new Date(dateString))
    }
}
